import { render, staticRenderFns } from "./npl-dwxf.vue?vue&type=template&id=567a9b04&scoped=true"
import script from "./npl-dwxf.vue?vue&type=script&lang=js"
export * from "./npl-dwxf.vue?vue&type=script&lang=js"
import style0 from "./npl-dwxf.vue?vue&type=style&index=0&id=567a9b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a9b04",
  null
  
)

export default component.exports